const namespace = 'PRICELIST';

export const RECEIVE_PRICELIST_SUCCESS = `${namespace}/RECEIVE_PRICELIST_SUCCESS`;
